//@flow
import type { ReducerState$Type,EditFormData } from './flowTypes'

export const transformDataToEditFormData=(data:any,leto: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const letoResultsetData = data['letoResultset']
    formData.isInvalidDoc = letoResultsetData['is_invalid_doc']?letoResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = letoResultsetData['is_override_vendor_name']?letoResultsetData['is_override_vendor_name']:false
    
    if (letoResultsetData['inv_no']){
        formData.invNo = letoResultsetData['inv_no']
    }
    if (letoResultsetData['inv_date']){
        formData.invDate = letoResultsetData['inv_date']
    }
    if (letoResultsetData['po_no']){
        formData.poNo = letoResultsetData['po_no']
    }
    if (letoResultsetData['item_total']){
        formData.itemTotal = letoResultsetData['item_total']
    }
    if (letoResultsetData['total']){
        formData.total = parseFloat(letoResultsetData['total'])
    }
    if (letoResultsetData['vendor_name']){
        formData.vendorName = letoResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/leto/editFormData.js